<template>
  <header>
    <nav class="navbar navbar-expand-lg navbar-light fixed-top">
      <div class="container px-0">
        <router-link
          :to="{ name: 'dashboard' }"
          class="navbar-brand mr-4">
          <img src="/img/logos/logo-capital-black.png" alt="Saxon Trust Logo">
        </router-link>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation">
          <base-icon icon="bars" />
        </button>
        <div
          id="navbarSupportedContent"
          class="collapse navbar-collapse">
          <ul class="navbar-nav ml-auto">
            <template v-if="!$auth.isAuthenticated">
              <li class="nav-item">
                <a @click.prevent="login" class="nav-link" href="#">
                  Login
                </a>
              </li>
              <li class="nav-item">
                <a @click.prevent="login" class="nav-link" href="#">
                  Register
                </a>
              </li>
            </template>
            <template v-else>
              <li class="nav-item">
                <router-link class="nav-link" :to="{ name: 'dashboard' }" exact>
                  Dashboard
                </router-link>
              </li>
              <li class="nav-item" v-if="$auth.admin() || $auth.borrower()">
                <router-link class="nav-link" :to="{ name: 'projects' }">
                  Projects
                </router-link>
              </li>
              <li class="nav-item" v-if="$auth.admin()">
                <router-link class="nav-link" :to="{ name: 'investments' }">
                  Investments
                </router-link>
              </li>
              <li class="nav-item" v-if="$auth.admin()">
                <router-link class="nav-link" :to="{ name: 'users' }">
                  Users
                </router-link>
              </li>
              <li class="nav-item" v-if="$auth.borrower()">
                <router-link class="nav-link" :to="{ name: 'asset-statements' }">
                  Asset Statements
                </router-link>
              </li>
              <li class="nav-item" v-if="$auth.borrower()">
                <router-link class="nav-link" :to="{ name: 'experience' }">
                  Experience
                </router-link>
              </li>
              <li class="nav-item" v-if="$auth.investor()">
                <router-link class="nav-link" :to="{ name: 'opportunities' }">
                  Investments
                </router-link>
              </li>
              <li class="nav-item" v-if="$auth.investor() && $auth.user.hasCofundingAccess">
                <router-link class="nav-link" :to="{ name: 'co-funding' }">
                  Co-funding
                </router-link>
              </li>
              <li class="nav-item" v-if="$auth.admin()">
                <router-link class="nav-link" exact :to="{ name: 'support-centre.admin' }">
                  Support
                </router-link>
              </li>
              <li class="nav-item" v-if="$auth.admin()">
                <router-link class="nav-link" exact :to="{ name: 'transactions' }">
                  Transactions
                </router-link>
              </li>
              <template v-if="$auth.investor() && $auth.user.accounts.length">
                <li class="nav-item balance">
                  <router-link class="nav-link" exact :to="{ name: 'account.funds' }">
                    <div class="d-flex align-items-center">
                      <div class="mr-2">
                        <base-icon icon="coins" />
                      </div>
                      <div>
                        <div class="balance-text sr-only font-family-secondary">
                          Balance
                        </div>
                        <div>
                          <span>{{ $formatting.toCurrency($auth.user.accounts[0].balance) }}</span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </li>
              </template>
              <li class="nav-item dropdown">
                <a
                  id="header-dropdown"
                  href="#"
                  class="nav-link"
                  data-toggle="dropdown">
                  Hello {{ $auth.user.profile.firstName }}
                  <span class="authenticated" :class="{ 'has-avatar': hasAvatar }">
                    <template v-if="hasAvatar">
                      <img :src="$auth.user.profile.avatar" alt="">
                    </template>
                    <template v-else>
                      <base-icon icon="user" />
                    </template>
                  </span>
                </a>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="header-dropdown"
                >
                  <router-link
                    v-if="$auth.investor()"
                    :to="{ name: 'bank-accounts' }"
                    class="dropdown-item">
                    Bank Accounts
                  </router-link>
                  <router-link
                    v-if="$auth.investor()"
                    :to="{ name: 'kyc.provide' }"
                    class="dropdown-item">
                    ID Documents
                  </router-link>
                  <router-link
                    :to="{ name: 'preferences' }"
                    class="dropdown-item"
                  >
                    Preferences
                  </router-link>
                  <router-link
                    v-if="$auth.investor()"
                    :to="{ name: 'statement' }"
                    class="dropdown-item">
                    Statement
                  </router-link>
                  <router-link
                    v-if="$auth.investor() || $auth.borrower()"
                    class="dropdown-item"
                    exact
                    :to="{ name: 'support-centre' }"
                  >
                    Support
                  </router-link>
                  <router-link
                    v-if="$auth.investor()"
                    class="dropdown-item"
                    exact
                    :to="{ name: 'account.withdraw' }"
                  >
                    Withdraw
                  </router-link>
                  <div class="dropdown-divider"/>
                  <button @click="logout" class="dropdown-item">
                    Logout
                  </button>
                </div>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'TheHeader',

  computed: {
    hasAvatar () {
      return this.$auth.isAuthenticated && this.$auth.user.profile && this.$auth.user.profile.avatar
    }
  },

  methods: {
    login () {
      this.$auth.loginWithRedirect()
    },

    logout () {
      this.$auth.logout({
        returnTo: window.location.origin
      })
    }
  }
}
</script>
